import type { CompanyProfile } from "../context/CompanyContext.tsx"

/** Portal login accounts provisioned for vendor companies (e.g. vendor_567-1). */
export function isVendorPortalUsername(username: string | null | undefined): boolean {
  if (!username) return false
  return username.toLowerCase().startsWith("vendor")
}

export function isVendorCompany(company: Pick<CompanyProfile, "company_type"> | null | undefined): boolean {
  return company?.company_type === "vendor"
}

/** Vendor management is only available on the main (independent) company account. */
export function canManageVendors(company: Pick<CompanyProfile, "company_type"> | null | undefined): boolean {
  return !isVendorCompany(company)
}
